import React, { useState, } from 'react'
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText, Button } from '@mui/material';
import { BASE_URL, CHAT_IDS, Rigi_CHAT_IDS, Rigi_CHAT_NAME, getRkbAppToken } from "../../utils/config";
import Loading from "../loading";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import Tooltip from '@mui/material/Tooltip';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Switch from "@mui/material/Switch";
import RefreshIcon from '@mui/icons-material/Refresh';
import SendIcon from '@mui/icons-material/Send';
import { styled } from "@mui/material/styles";
import { useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const IndexIntradayTable = (props) => {

  const navigate = useNavigate();
  console.log("rpops", props)

  const Intradaycolumns = [

    { id: "Remove", label: "Action", minWidth: 80 },
    { id: 'SignalType', label: 'Stock Name', minWidth: 120 },
    { id: 'SignalDT', label: 'SignalDT', minWidth: 110 },
    { id: 'StockPrice', label: 'Cash CMP', minWidth: 90 },
    { id: 'Current_stock_cmp', label: 'Current Cash CMP', minWidth: 90 },
    { id: 'FuturePrice', label: 'FuturePrice', minWidth: 110 },
    { id: 'Current_future_cmp', label: 'Current FuturePrice', minWidth: 110 },
    { id: 'OptionPrice', label: 'OptionPrice', minWidth: 110 },
    { id: 'Current_option_cmp', label: 'Current OptionPrice', minWidth: 110 },
    { id: 'OptionStrike', label: 'StrikePrice', minWidth: 80 },
    { id: 'OptionExpiry', label: 'Expiry', minWidth: 110 },
    { id: 'Stoploss', label: 'Stoploss', minWidth: 100 },
    { id: 'lot_size', label: 'LotSize', minWidth: 80 },
    { id: 'LastCheckedDT', label: 'LastCheckedDT', minWidth: 110 },
    { id: 'OptionHigh', label: 'OptionHigh', minWidth: 90 },
    { id: 'StockHigh', label: 'CMP High', minWidth: 90 },
    { id: 'FutureHigh', label: 'FutureHigh', minWidth: 90 },
    { id: 'OptionLow', label: 'OptionLow', minWidth: 90 },
    { id: 'StockLow', label: 'CMP Low', minWidth: 90 },
    { id: 'FutureLow', label: 'FutureLow', minWidth: 90 },
    { id: 'OptionHighDT', label: 'OptionHighDT', minWidth: 110 },
    { id: 'StockHighDT', label: 'CMP HighDT', minWidth: 110 },
    { id: 'FutureHighDT', label: 'FutureHighDT', minWidth: 110 },
    { id: 'OptionLowDT', label: 'OptionLowDT', minWidth: 110 },
    { id: 'StockLowDT', label: 'CMP LowDT', minWidth: 110 },
    { id: 'FutureLowDT', label: 'FutureLowDT', minWidth: 110 },
    { id: 'symbol', label: 'Symbol', minWidth: 100 },
    { id: 'Interval_Time', label: 'Interval', minWidth: 80 },
    { id: 'box_size', label: 'Brick Size', minWidth: 80 },
    { id: 'Buy_sell_box', label: 'Buy/Sell Box', minWidth: 80 },
    { id: 'Exit_Box', label: 'Exit Box', minWidth: 80 }
  ];



  const Record = props.Record
  const heading = props.heading
  const updateSLchange = props.updateSLchange
  const RecordColor = props.RecordColor
  const PreviousRecord = props.PreviousClose
  console.log(`Record for ${heading}`)
  const [authdata, setAuthData] = useState({
    username: '',
    password: ''
  });
  const [cmp, setCMP] = useState('')
  const [stockPrice, setStockPrice] = useState('');
  const [futurePrice, setFuturePrice] = useState('');
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(25);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState({});
  const [checked, setChecked] = useState(true);
  const [DelSelectedRecord, setDelSelectedRecord] = useState({});
  const [authenticationOpen, setAuthenticationOpen] = useState(false);
  const [SLEditOpen, setSLEditOpen] = useState(false);
  const [RemoveAlert, SetRemoveAlert] = useState(false);
  const [BookPorL, setBookPorL] = useState('')
  const [optionBookPorL, setOptionBookPorL] = useState('')
  const [futureBookPorL, setFutureBookPorL] = useState('')
  const [newsl, setNewSL] = useState("");
  const [showInvalidPasswordAlert, setShowInvalidPasswordAlert] = useState(false);
  const [Errorshow, setErrorShow] = useState(false);
  const [Errormessage, setErrorMessage] = useState('');
  const [favourablePoint, setFavourablePoint] = useState(0);

  const [newRecords, setNewRecords] = useState([]);
  const [AlertMessage, setAlertMessage] = useState("");
  const [showAlert, setshowAlert] = useState(false);
  const [commentrymessage, setCommentryMessage] = useState()
  const [automateRemark, setAutomateRemark] = useState(false);
  const TELEGRAM_API_TOKEN = '6848586856:AAE_JEYn2MH2j16n0fYD-1V9adL0QDknS7I';
  const passwordRegex =
    /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+[\]{};:<>?]{8,}$/;

  const [MessageSLandFirstTraget, setMessageSLandFirstTraget] = useState(false);
  const [SlandFirstTargetmsg, setSlandFirstTargetmsg] = useState("");


  // handle close book profit or loss dialog
  const handleClose = () => {
    setCommentryMessage('');
    setOpenDialog(false);
    setChecked(true)
  };

  // handle change page for pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    let startindex = newPage * rowsPerPage;
    console.log("startindex", startindex)
    let endindex = Math.min(startindex + rowsPerPage, Record.length)
    console.log("endindex", endindex)
    setStartIndex(startindex);
    setEndIndex(endindex)

  };

  // handle change rows per page for pagination
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setEndIndex(+event.target.value);
    setStartIndex(0);
    setPage(0);
  };

  // format date and time for LastCheckedDT column
  const formatDateTime = (row) => {

    // console.log("row.datetime",row.datetime)

    let date = new Date(row.datetime);
    // console.log("timeDate",date)
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    // Format the date and time
    const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`;

    //  console.log(formattedDate);
    return formattedDate
  };


  // format date and time for OptionExpiry column
  const formatExpiry = (row) => {



    let date = new Date(row.OptionExpiry);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    // Format the date and time
    const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`;

    //  console.log(formattedDate);
    return formattedDate
  }




  // handle send favourable moves in telegram and send signal to telegram when click on automation table
  const handleSLMesageSend = (row) => {
    try {
      setSelectedRecord(row);

      if (props.tablename === "AutomateIndexIntradaySL") {
        console.log("handleSLMesageSend for automate message for newsl", row);
        setAutomateRemark(true);
        // Sent to telegram API will be implemented here
      } else {
        console.log("handleSLMesageSend message for newsl", row);

        if (row.SignalFinal === "SELL PUT Index/Intraday") {
          let favourableMove = row.StockPrice - row.Current_stock_cmp;
          favourableMove = favourableMove.toFixed(2);
          setFavourablePoint(favourableMove);
        } else {
          let favourableMove = row.Current_stock_cmp - row.StockPrice;
          favourableMove = favourableMove.toFixed(2);
          setFavourablePoint(favourableMove);
        }

        setMessageSLandFirstTraget(true);
      }
    } catch (error) {
      console.error("Error in handleSLMesageSend:", error);
      setAlertMessage("An error occurred while processing the request.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('');
      }, 3000);
    }
  };


  // handle close dialog for send favourable moves in telegram and send signal to telegram when click on automation table
  const handleSLandFirstTragetClose = () => {
    setMessageSLandFirstTraget(false);
    setSlandFirstTargetmsg("");

  }


  // handle send favourable moves in telegram and send signal to telegram when click on automation table
  const SLandFirstSendToTelegram = async () => {
    console.log("Selected record for favourable point", selectedRecord);
    setLoading(true);

    try {
      let chatId = CHAT_IDS['IndexIntraday'];
      let RigichatId = Rigi_CHAT_IDS['IndexIntraday'];
      let Rigichatname = Rigi_CHAT_NAME['IndexIntraday'];

      let message = `Dear Traders,  
We Got ${favourablePoint} favourable moves in ${selectedRecord.SignalType}.`;

      const customMessage = SlandFirstTargetmsg?.trim() ? `\nRemark: ${SlandFirstTargetmsg}` : "";
      const finalMessage = message + customMessage;

      if (finalMessage) {
        // Send to Rigi API
        const params2 = {
          content: finalMessage,
          attachments: "",
          type: "normal",
          notification_title: Rigichatname,
          description: finalMessage,
          soundName: "tone4",
          notificationToneName: "Tone4",
          groupId: RigichatId,
          textColor: "#ffd",
          sendToTelegram: 0,
          bgColor: "#000"
        };

        const body2 = JSON.stringify(params2);

        const rkbAppToken = await getRkbAppToken();

        const rigiResponse = await fetch(`https://api.rakeshbansalventures.com/api/messages`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${rkbAppToken}`
          },
          body: body2,
        });

        if (!rigiResponse.ok) {
          throw new Error(`Failed to send message to Rigi API: ${rigiResponse.statusText}`);
        }

        // Send to Telegram API
        const telegramResponse = await fetch(`https://api.telegram.org/bot${TELEGRAM_API_TOKEN}/sendMessage`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            chat_id: chatId,
            text: finalMessage,
            parse_mode: 'HTML',
          }),
        });

        if (!telegramResponse.ok) {
          throw new Error(`Failed to send message to Telegram API: ${telegramResponse.statusText}`);
        }

        const messageSendResult = await telegramResponse.json();
        console.log("Message send response", messageSendResult);
      }

      setLoading(false);
      setSlandFirstTargetmsg("");
      setSelectedRecord({});
      setMessageSLandFirstTraget(false);
    } catch (error) {
      console.error('Error sending to Telegram:', error);
      setAlertMessage(`Error: ${error.message}`);
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('');
      }, 3000);
      setLoading(false);
    }
  };


  // handle authentication close dialog
  const handleAuthenticationClose = () => {
    setAuthData({
      username: '',
      password: ''
    })
    setAuthenticationOpen(false)
  }

  // handle sl edit  close dialog
  const handleSLEditClose = () => {
    setSLEditOpen(false)
  }



  // handle authentication submit
  const handleAuthSubmit = async (e) => {
    e.preventDefault();
    console.log("inside auth handler");
    setLoading(true);

    try {
      if (!passwordRegex.test(authdata.password)) {
        setShowInvalidPasswordAlert(true);
        setTimeout(() => {
          setShowInvalidPasswordAlert(false);
        }, 2000);
        setLoading(false);
        return;
      }

      if (!authdata.username || !authdata.password) {
        setAlertMessage("Username and password are required.");
        setshowAlert(true);
        setTimeout(() => {
          setshowAlert(false);
          setAlertMessage('');
        }, 1500);

      }

      const body = JSON.stringify({ AuthDetails: authdata });
      const response = await fetch(`${BASE_URL}/authsledit`, {
        method: "POST",
        body,
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const res = await response.json();
      console.log("res", res);

      if (res.success) {
        console.log("auth pass");
        setLoading(false);
        setAuthData({
          username: '',
          password: ''
        });
        setAuthenticationOpen(false);
        setSLEditOpen(true);
      } else {
        setLoading(false);

        setAlertMessage(res.message || "Authentication failed.");
        setshowAlert(true);
        setTimeout(() => {
          setshowAlert(false);
          setAlertMessage('');
        }, 1500);
      }
    } catch (error) {
      console.error("Error in handleAuthSubmit:", error);
      setLoading(false);
      setAlertMessage(error.message || "Internal Server Error.");

      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('');
      }, 1500);
    }
  };

  // handle SL change submit
  const handleSLChangeSubmit = (e) => {
    e.preventDefault();
    console.log("inside sl handler", newsl);
    console.log("inside sl selected record", selectedRecord);

    if (!newsl || isNaN(newsl)) {
      setErrorMessage("Please enter a valid numeric value for Stop Loss.");
      setErrorShow(true);
      setTimeout(() => {
        setErrorShow(false);
        setErrorMessage('');
      }, 3000);
      return;
    }

    var table_name = props.tablename;

    if (table_name === "AutomateIndexIntradaySL") {
      table_name = "AutomateIndexIntradaySL";
    } else {
      table_name = "IndexIntradaySL";
    }

    try {
      let loginuser = JSON.parse(localStorage.getItem("loginData"));
      fetch(`${BASE_URL}/editsl?id=${selectedRecord.id}&type=${table_name}&value=${newsl}&modified_by=${loginuser.user_id}`, {
        method: "PUT",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${loginuser.token}`
        },
      })
        .then((res) => res.json())
        .then((res) => {
          console.log("res", res);
          if (res.success === true) {
            console.log("SL edit success");
            setSLEditOpen(false);
            updateSLchange();

            setTimeout(() => {
              setLoading(false);
            }, 2000);
          } else {
            setLoading(false);
            setAlertMessage(res.message || "Failed to update Stop Loss.");

            setshowAlert(true);
            setTimeout(() => {
              setshowAlert(false);
              setAlertMessage('');
            }, 1500);
          }
        })
        .catch((error) => {
          console.error("Error in SL update:", error);
          setLoading(false);

          setAlertMessage(error.message || "Internal Server Error.");
          setshowAlert(true);
          setTimeout(() => {
            setshowAlert(false);
            setAlertMessage('');
          }, 1500);
        });
    } catch (error) {
      console.error("Error in SL handler:", error);
      setLoading(false);
      setAlertMessage("Internal Server Error.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('');
      }, 1500);
    }
  };



  //  handle auth chnage username and password
  const handleAuthChange = (e) => {
    const { name, value } = e.target;
    setAuthData((prevState) => {
      const newState = {
        ...prevState,
        [name]: value
      };


      return newState;
    });
  };

  // handle book profit or loss submit
  const handleBookProfitOrLoss = (e, BookPorL) => {
    e.preventDefault();

    try {
      if (!selectedRecord || !cmp) {
        setAlertMessage("Required values are missing. Please try again.");

        setshowAlert(true);
        setTimeout(() => {
          setshowAlert(false);
          setAlertMessage('');
        }, 1500);
        return;
      }

      let date = new Date();
      let bodydata = JSON.stringify({
        BookPL: BookPorL,
        IsCommentary: checked,
        CommentryMessage: commentrymessage,
        StockPrice: stockPrice,
        FuturePrice: futurePrice,
      });

      fetch(`${BASE_URL}/closePositionIndexIntraday?id=${selectedRecord.id}&cmpPrice=${cmp}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: bodydata,
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.success === true) {
            console.log("Book Profit or Close Position edit Success");
            setOpenDialog(false);
            updateSLchange();
            setCommentryMessage('');
            setTimeout(() => {
              setLoading(false);
            }, 2000);
          } else {
            throw new Error(res.message || "Failed to process the request.");
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          setLoading(false);
          setAlertMessage(error.message || "An error occurred while processing the request.");

          setshowAlert(true);
          setTimeout(() => {
            setshowAlert(false);
            setAlertMessage('');
          }, 1500);
        });
    } catch (error) {
      console.error("Error:", error);
      setLoading(false);
      setAlertMessage(error.message || "Internal Server Error.");

      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('');
      }, 1500);
    }
  };

  // handle change stoploss
  const handleSLChange = (e) => {
    let value = e.target.value
    if (/^\d*\.?\d{0,2}$/.test(value)) {
      setNewSL(value)
    }
    else {
      setErrorMessage('Numeric input with 2 decimal places (0-9).')
      setErrorShow(true)
      setTimeout(() => {
        setErrorShow(false)
        setErrorMessage('')
      }, 3000)
      console.log("SL hold 2point value")
    }
  }




  // handle calculate porfit or loss for stock price
  const StockcalCurrComp = (row) => {

    let value
    let percentDifference

    if (row.SignalFinal === "SELL PUT Index/Intraday") {
      value = row.StockPrice - row.Current_stock_cmp
      value = value.toFixed(2);
      percentDifference = ((value / row.StockPrice) * 100).toFixed(2);
    }
    else {
      value = row.Current_stock_cmp - row.StockPrice
      value = value.toFixed(2);
      percentDifference = ((value / row.StockPrice) * 100).toFixed(2);
    }
    // console.log("value",value)
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {row.Current_stock_cmp === '' ? (
          <span>{row.Current_stock_cmp}</span>
        ) : (
          <div>
            <span>{row.Current_stock_cmp}</span> |
            <div>
              <span>
                {value >= 0 ? <ArrowDropUpIcon fontSize="small" sx={{ color: 'green' }} /> : <ArrowDropDownIcon fontSize="small" sx={{ color: 'red' }} />}
              </span>
              <span style={{ color: value >= 0 ? 'green' : 'red' }}>{`${Math.abs(value)}(${percentDifference}%)`}</span>
            </div>
          </div>

        )}
      </div>
    )
  }
  // handle calculate porfit or loss for option price
  const OptioncalCurrComp = (row) => {

    let value
    let percentDifference

    if (row.SignalFinal === "SELL PUT Index/Intraday") {
      value = row.Current_option_cmp - row.OptionPrice
      value = value.toFixed(2);
      percentDifference = ((value / row.OptionPrice) * 100).toFixed(2);
    }
    else {
      value = row.Current_option_cmp - row.OptionPrice
      value = value.toFixed(2);
      percentDifference = ((value / row.OptionPrice) * 100).toFixed(2);
    }
    // console.log("value",value)
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {row.Current_option_cmp === '' ? (
          <span>{row.Current_option_cmp}</span>
        ) : (
          <div>
            <span>{row.Current_option_cmp}</span> |
            <div>
              <span>
                {value >= 0 ? <ArrowDropUpIcon fontSize="small" sx={{ color: 'green' }} /> : <ArrowDropDownIcon fontSize="small" sx={{ color: 'red' }} />}
              </span>
              <span style={{ color: value >= 0 ? 'green' : 'red' }}>{`${Math.abs(value)}(${percentDifference}%)`}</span>
            </div>
          </div>

        )}
      </div>
    )
  }
  // handle calculate porfit or loss for future price
  const FuturecalCurrComp = (row) => {

    let value
    let percentDifference

    if (row.SignalFinal === "SELL PUT Index/Intraday") {
      value = row.FuturePrice - row.Current_future_cmp
      value = value.toFixed(2);
      percentDifference = ((value / row.FuturePrice) * 100).toFixed(2);
    }
    else {
      value = row.Current_future_cmp - row.FuturePrice
      value = value.toFixed(2);
      percentDifference = ((value / row.FuturePrice) * 100).toFixed(2);
    }
    // console.log("value",value)
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {row.Current_future_cmp === '' ? (
          <span>{row.Current_future_cmp}</span>
        ) : (
          <div>
            <span>{row.Current_future_cmp}</span> |
            <div>
              <span>
                {value >= 0 ? <ArrowDropUpIcon fontSize="small" sx={{ color: 'green' }} /> : <ArrowDropDownIcon fontSize="small" sx={{ color: 'red' }} />}
              </span>
              <span style={{ color: value >= 0 ? 'green' : 'red' }}>{`${Math.abs(value)}(${percentDifference}%)`}</span>
            </div>
          </div>

        )}
      </div>
    )
  }

  // handle  open dialog to remove row from table
  const handleremove = (row) => {
    setDelSelectedRecord(row);
    SetRemoveAlert(true);
  }

  // handle submit for remove row from table
  const handleremoveRow = async () => {
    try {
      SetRemoveAlert(false);

      if (!DelSelectedRecord || !DelSelectedRecord.id) {
        setAlertMessage("No record selected for deletion.");
        setshowAlert(true);
        setTimeout(() => {
          setshowAlert(false);
        }, 3000);
        return;
      }

      // if (!props.tablename) {
      //   setAlertMessage("Table name is missing.");
      //   setshowAlert(true);
      //   setTimeout(() => {
      //     setshowAlert(false);
      //   }, 3000);
      //   return;
      // }

      console.log("DelSelectedRecord:", DelSelectedRecord.id);
      console.log("props.tablename", props.tablename);

      let table_name = props.tablename === "AutomateIndexIntradaySL"
        ? "renko.data_feed_renko_decisions"
        : "IndexIntraday";

      console.log("table name ", table_name);

      let loginuser = JSON.parse(localStorage.getItem("loginData"));
      if (!loginuser || !loginuser.user_id || !loginuser.token) {
        setAlertMessage("User is not logged in or missing credentials.");
        setshowAlert(true);
        setTimeout(() => {
          setshowAlert(false);
        }, 3000);
        return;
      }

      let data = JSON.stringify({ tablename: table_name, modified_by: loginuser.user_id });

      const response = await fetch(`${BASE_URL}/RemoveRow/${DelSelectedRecord.id}`, {
        method: "PUT",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${loginuser.token}`
        },
        body: data,
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const res = await response.json();

      if (res.success === true) {
        updateSLchange();
        setAlertMessage(res.message);
        setshowAlert(true);
        setTimeout(() => {
          setshowAlert(false);
        }, 3000);
      } else {
        setAlertMessage(res.message || "Failed to remove the row.");
        setshowAlert(true);
        setTimeout(() => {
          setshowAlert(false);
        }, 3000);
      }
    } catch (error) {
      console.error("Error in handleremoveRow:", error);
      setAlertMessage(error.message || "An error occurred while removing the row.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
      }, 3000);
    }
  };




  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor:
            theme.palette.mode === "dark" ? "#2ECA45" : "#23499E",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #23499E",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));

  // handle change radio button for send to telegram when send signal form automate report
  const handleChange = (event) => {
    event.preventDefault();
    console.log("event.target.checked", event.target.checked);
    setChecked(event.target.checked);
  };

  // handle send signal to telegram when send signal form automate report
  const automateSendToTelegram = async () => {
    try {
      setAutomateRemark(false);
      setLoading(true);

      if (!selectedRecord || !selectedRecord.SignalFinal) {
        throw new Error("Selected record is missing or invalid.");
      }

      const eventDate = new Date();
      const day = eventDate.getDate();
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      const month = monthNames[eventDate.getMonth()];
      const year = eventDate.getFullYear();
      const formattedDate = `${day} ${month} ${year}`;

      const loginuser = JSON.parse(localStorage.getItem("loginData"));
      if (!loginuser || !loginuser.token || !loginuser.user_id) {
        throw new Error("User is not logged in or missing credentials.");
      }

      const reportType =
        selectedRecord.SignalFinal === "BUY CALL Index/Intraday"
          ? "IndexIntradayBUY"
          : "IndexIntradaySELL";

      const send_telegram = checked ? "Yes" : "No";

      const response = await fetch(`${BASE_URL}/createAutomateIndexIntradayReport`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${loginuser.token}`,
        },
        body: JSON.stringify({
          eventType: "IndexIntraday",
          ReportName: reportType,
          ReportData: selectedRecord,
          reportDate: formattedDate,
          createdBy: loginuser.user_id,
          CommentryMessage: commentrymessage,
          sendTelegram: send_telegram,
        }),
      });

      const res = await response.json();

      if (response.ok && res.success) {
        console.log("Data:", res.data);
        setAlertMessage(res.message);
        setshowAlert(true);
        updateSLchange();
      } else if (response.status === 401 || response.status === 403) {
        localStorage.clear();
        navigate("/login");
      } else {
        throw new Error(res.message || "Failed to send the report.");
      }
    } catch (error) {
      console.error("Error in automateSendToTelegram:", error);
      setAlertMessage(error.message || "An error occurred while sending the report.");
      setshowAlert(true);
    } finally {
      setLoading(false);
      setSelectedRecord("");
      setCommentryMessage("");
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('');
      }, 3000);
    }
  };


  // handle close dialog for send signal to telegram when send signal form automate report
  const handleAutomateRemarkClose = async () => {
    setAutomateRemark(false);
    setSelectedRecord("");
    setCommentryMessage("");
  }


  // handle refresh book profit or loss price when popup us open 
  const RefreshBOOKPL = async () => {
    // selectedRecord
    setLoading(true)
    let url



    if (selectedRecord.SignalFinal === "BUY CALL Index/Intraday" || selectedRecord.SignalFinal === "SELL PUT Index/Intraday") {
      url = `${BASE_URL}/getcmpdashboard/${selectedRecord.StockInsToken}/${selectedRecord.OptionInsToken}/${selectedRecord.FutureInsToken}`
    } else {
      url = `${BASE_URL}/getcmpdashboard/${selectedRecord.InstrumentToken}/${selectedRecord.Stock_InsToken}/futureToken`
    }

    await fetch(`${url}`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((res) => {
        console.log("res", res);
        if (res.success === true) {
          console.log("auth pass")
          setCMP(res.data)
          setStockPrice(res.StockPrice)
          setFuturePrice(res.FuturePrice)
          let cmpvalue
          let stockvalue
          let Futurevalue
          if (selectedRecord.SignalFinal === "BUY CALL Index/Intraday") {
            cmpvalue = res.data - selectedRecord.StockPrice
            cmpvalue = cmpvalue.toFixed(2);

            stockvalue = res.StockPrice - selectedRecord.OptionPrice
            stockvalue = stockvalue.toFixed(2);

            Futurevalue = res.FuturePrice - selectedRecord.FuturePrice
            Futurevalue = Futurevalue.toFixed(2);
          } else {
            cmpvalue = selectedRecord.StockPrice - res.data
            cmpvalue = cmpvalue.toFixed(2);

            stockvalue = res.StockPrice - selectedRecord.OptionPrice
            stockvalue = stockvalue.toFixed(2);

            Futurevalue = selectedRecord.FuturePrice - res.FuturePrice
            Futurevalue = Futurevalue.toFixed(2);
          }


          setBookPorL(cmpvalue)
          setOptionBookPorL(stockvalue)
          setFutureBookPorL(Futurevalue)


          console.log("print bookPorL", BookPorL)
          setOpenDialog(true);
          setLoading(false)

        }
        else {
          console.error("CMP not found. Please check the response data or API endpoint.")
          setLoading(false)
          setAlertMessage(res.message || "CMP data not found. Please try again.")
          setshowAlert(true)
          setTimeout(() => {
            setshowAlert(false)
            setAlertMessage('')
          }, 1500)
        }
      }).catch((error) => {
        console.error("Error fetching CMP data:", error)
        setLoading(false)
        setAlertMessage(error.message || "An error occurred while fetching CMP data.")
        setshowAlert(true)
        setTimeout(() => {
          setshowAlert(false)
          setAlertMessage('')
        }, 1500)
      })
  }

  // handle hyperlink stock name to fetch CMP data
  const hyperLinkStockName = async (row) => {
    try {
      console.log("rowData", row);
      if (!row || !row.SignalFinal) {
        throw new Error("Invalid row data. Please check the input.");
      }

      setSelectedRecord(row);
      setLoading(true);

      let url;
      if (row.SignalFinal === "BUY CALL Index/Intraday" || row.SignalFinal === "SELL PUT Index/Intraday") {
        if (!row.StockInsToken || !row.OptionInsToken || !row.FutureInsToken) {
          throw new Error("Required tokens are missing for the selected row.");
        }
        url = `${BASE_URL}/getcmpdashboard/${row.StockInsToken}/${row.OptionInsToken}/${row.FutureInsToken}`;
      } else {
        if (!row.InstrumentToken || !row.Stock_InsToken) {
          throw new Error("Required tokens are missing for the selected row.");
        }
        url = `${BASE_URL}/getcmpdashboard/${row.InstrumentToken}/${row.Stock_InsToken}/futureToken`;
      }

      const response = await fetch(url, { method: "GET" });
      const res = await response.json();

      if (response.ok && res.success) {
        console.log("Response data:", res);
        setCMP(res.data);
        setStockPrice(res.StockPrice);
        setFuturePrice(res.FuturePrice);

        let cmpvalue, stockvalue, Futurevalue;
        if (row.SignalFinal === "BUY CALL Index/Intraday") {
          cmpvalue = (res.data - row.StockPrice).toFixed(2);
          stockvalue = (res.StockPrice - row.OptionPrice).toFixed(2);
          Futurevalue = (res.FuturePrice - row.FuturePrice).toFixed(2);
        } else {
          cmpvalue = (row.StockPrice - res.data).toFixed(2);
          stockvalue = (res.StockPrice - row.OptionPrice).toFixed(2);
          Futurevalue = (row.FuturePrice - res.FuturePrice).toFixed(2);
        }

        setBookPorL(cmpvalue);
        setOptionBookPorL(stockvalue);
        setFutureBookPorL(Futurevalue);

        console.log("BookPorL values:", { cmpvalue, stockvalue, Futurevalue });
        setOpenDialog(true);
      } else {
        throw new Error(res.message || "CMP data not found. Please try again.");
      }
    } catch (error) {
      console.error("Error in hyperLinkStockName:", error.message);
      setAlertMessage(error.message || "An error occurred while fetching data.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
      }, 3000);
    } finally {
      setLoading(false);
    }
  };

  // handle Sl change input when dialog open
  const handleStockLossChange = (row) => {
    // setNewSL(row["Stoploss"]);
    console.log("row Data for sl change", row);
    console.log("row Data for sl change", row.Stoploss);
    setSelectedRecord(row);
    setNewSL(row.Stoploss)
    setAuthenticationOpen(true);
  }



  return (
    <div className='screenerTab'>

      {loading ? (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 2,
          }}

        >
          <Loading />
        </div>
      ) : null}


      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table style={{ margin: 0 }} stickyHeader aria-label="sticky table">
            <TableHead >

              <TableRow>
                {Intradaycolumns.map((column, index) => (

                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      textAlign: 'center',
                      minWidth: column.minWidth,
                      backgroundColor: '#23499E',
                      color: 'white',
                      zIndex: column.id === "SignalType" || column.id === "Remove" ? 20 : 5,
                      left: column.id === "SignalType" ? 80 : column.id === "Remove" ? 0 : undefined

                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}


              </TableRow>
            </TableHead>
            <TableBody>
              {Record
                .slice(startIndex, endIndex)
                .map((row, index) => {
                  const isNewRecord = newRecords.some(newRecord => newRecord.id === row.id);
                  // console.log("isNewRecord",isNewRecord)
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                      {Intradaycolumns.map((column) => {
                        const value = row[column.id];

                        return (
                          <TableCell
                            style={{
                              position: 'sticky',
                              backgroundColor: RecordColor == 1 ? '#fff' : isNewRecord ? 'lightgreen' : '#fff',
                              zIndex: column.id === "SignalType" || column.id === "Remove" ? 10 : 1,
                              left: column.id === "SignalType" ? 80 : column.id === "Remove" ? 0 : undefined
                            }}
                            class="table-cell-screenerTab"
                            key={column.id}
                            align={column.align}
                          >
                            {column.id === "S.No"
                              ? index + 1
                              : column.id === "datetime"
                                ? formatDateTime(row)
                                : column.id === "OptionExpiry"
                                  ? formatExpiry(row)
                                  : column.id === 'Stoploss'
                                    ? <div style={{ color: 'blue', cursor: 'pointer' }} onClick={() => handleStockLossChange(row)}>
                                      {value}
                                    </div>
                                    : column.id === 'Remove'
                                      ? <div>
                                        <span style={{ color: '#454545', cursor: 'pointer', marginLeft: '10px', marginRight: '10px' }}
                                          onClick={() => handleremove(row)}
                                        >
                                          <Tooltip title={"Remove row"} placement="right">
                                            <HighlightOffIcon sx={{ width: 20, height: 20 }} />
                                          </Tooltip>

                                        </span>
                                        <span>
                                          <Tooltip title={props.tablename === 'AutomateIndexIntradaySL' ? "Send Signal To Telegram." : "Send Favorable Point Gain Message."}>
                                            <SendIcon sx={{ width: 20, height: 20 }} onClick={() => { handleSLMesageSend(row) }} />
                                          </Tooltip></span>
                                      </div>
                                      : column.id === 'Current_stock_cmp'
                                        ? StockcalCurrComp(row)
                                        : column.id === 'Current_option_cmp'
                                          ? OptioncalCurrComp(row)
                                          : column.id === 'Current_future_cmp'
                                            ? FuturecalCurrComp(row)
                                            : column.id === 'SignalType' ?
                                              <div
                                                style={
                                                  props.tablename === "AutomateIndexIntradaySL"
                                                    ? {}
                                                    : { color: 'blue', fontWeight: '600', cursor: 'pointer' }
                                                }
                                                onClick={
                                                  props.tablename === "AutomateIndexIntradaySL" ? undefined : () => hyperLinkStockName(row)
                                                }
                                              >
                                                {row.SignalType} {row.SignalFinal === "BUY CALL Index/Intraday" ? 'BUY' : 'SELL'}
                                              </div>

                                              : value
                            }
                          </TableCell>
                        );
                      })}

                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[25, 50, 75, 100]}
          component="div"
          count={Record.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>



      {/* dialog for book profit and book loss */}
      <Dialog
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className='screener-bookprofit'
      >
        <DialogTitle id="alert-dialog-title">
          {BookPorL >= 0 ? 'Book Profit' : 'Book Loss'}
        </DialogTitle>
        <DialogContent className='dialog-content' >
          <div className="Authmain">
            <div className="Authcontent">
              <div style={{ textAlign: 'center' }}>
                <span style={{ cursor: 'pointer', color: '#23499E' }} onClick={RefreshBOOKPL}><Tooltip title={"Refresh Data"} placement="right">
                  <RefreshIcon sx={{ width: 20, height: 20, color: '#23499E' }} />
                </Tooltip>Refresh</span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                  <div>
                    <h4 style={{ display: 'inline' }}>Cash CMP</h4>


                    <div className='indexcmp-value'>
                      <span>{cmp} {BookPorL >= 0 ? <ArrowDropUpIcon fontSize="small" color="success" /> : <ArrowDropDownIcon fontSize="small" sx={{ color: 'red' }} />}</span>
                      <span style={{ color: BookPorL >= 0 ? 'green' : 'red' }}>{BookPorL}</span>
                    </div>
                  </div>

                  <div>
                    <h4 style={{ display: 'inline' }}>Future CMP:</h4>
                    <div className='indexcmp-value'>
                      <span>{futurePrice}{futureBookPorL >= 0 ? <ArrowDropUpIcon fontSize="small" color="success" /> : <ArrowDropDownIcon fontSize="small" sx={{ color: 'red' }} />}</span>
                      <span style={{ color: futureBookPorL >= 0 ? 'green' : 'red' }}>{futureBookPorL}</span>
                    </div>
                  </div>

                  <div>
                    <h4 style={{ display: 'inline' }}>Option CMP:</h4>
                    <div className='indexcmp-value'>
                      <span>{stockPrice}{optionBookPorL >= 0 ? <ArrowDropUpIcon fontSize="small" color="success" /> : <ArrowDropDownIcon fontSize="small" sx={{ color: 'red' }} />}</span>
                      <span style={{ color: optionBookPorL >= 0 ? 'green' : 'red' }}>{optionBookPorL}</span>
                    </div>
                  </div>


                </div>

                <div style={{ width: '100%' }}>
                  <label htmlFor="withCommentery" style={{ marginRight: '10px' }}>With Commentary</label>
                  <IOSSwitch
                    sx={{ m: 1 }}
                    defaultChecked
                    checked={checked}
                    onChange={handleChange}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </div>
                <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                  <label htmlFor="Commentry" style={{ marginRight: '10px' }}>Commentary</label>
                  <textarea
                    id="inputField"
                    style={{ border: '2px solid #000' }}
                    placeholder="Type a message"
                    value={commentrymessage}
                    onChange={(e) => setCommentryMessage(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={(e) => handleBookProfitOrLoss(e, BookPorL >= 0 ? 'Book Profit' : 'Close Position')}>
            {BookPorL >= 0 ? 'Book Profit' : 'Close Position'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* dialog for authencation */}
      <Dialog
        open={authenticationOpen}
        onClose={handleAuthenticationClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className='screener-bookprofit'
      >
        <DialogTitle id="alert-dialog-title">
          {"Authentication to change SL"}

        </DialogTitle>
        {loading ? (
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 2,
            }}

          >
            <Loading />
          </div>
        ) : null}
        <form onSubmit={handleAuthSubmit}>
          <DialogContent className='dialog-content'>
            <div className="Authmain">
              <div className="Authcontent">
                {Errorshow ?
                  <span style={{ color: "red" }}>
                    {Errormessage}
                  </span>
                  : null}
                <div>
                  <p>Username :<span className='asterisk'>*</span></p>
                  <input value={authdata.username} type="email" id="username" name="username" required onChange={handleAuthChange} autocomplete="off" placeholder="Enter username" />
                </div>

                {showInvalidPasswordAlert && (
                  <span>
                    Please enter a valid password. Passwords must be at least 8
                    characters long and contain at least one letter, one digit, and
                    may include special characters.
                  </span>
                )}
                <div>
                  <p>Password :<span className='asterisk'>*</span></p>
                  <input value={authdata.password} type="password" id="password" name="password" required onChange={handleAuthChange} autocomplete="off" placeholder="Enter Password" />
                </div>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button className='btn-cancel' onClick={handleAuthenticationClose}>Cancel</Button>

            <input type="submit" value="Submit" className='btn-submit'
              style={{ width: '70px', borderRadius: '5px', cursor: authdata.username === '' || authdata.password === '' ? 'not-allowed' : 'pointer' }}
              disabled={authdata.username === '' || authdata.password === ''} />
          </DialogActions>
        </form>
      </Dialog>

      {/* dialog for sl change  */}

      <Dialog
        open={SLEditOpen}
        onClose={handleSLEditClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className='screener-bookprofit'
      >
        <DialogTitle id="alert-dialog-title">
          {"Enter New Stop Loss"}
        </DialogTitle>
        <DialogContent className='dialog-content'>
          {loading ? (
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 2,
              }}

            >
              <Loading />
            </div>
          ) : null}

          <div className="Authmain">
            <div className="Authcontent">
              {Errorshow ?
                <span style={{ color: "red" }}>
                  {Errormessage}
                </span>
                : null}
              <div className="popup-slvalue">
                <p>Stop Loss:<span className='asterisk'>*</span></p>
                <div>
                  <RemoveIcon onClick={() => setNewSL(newsl - 10)} />
                  <input value={newsl} type="number" id="sl" name="sl" required onChange={handleSLChange} />
                  <AddIcon onClick={() => setNewSL(newsl + 10)} />
                </div>
              </div>

            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button className='btn-cancel' onClick={handleSLEditClose}>cancel</Button>
          <Button className='btn-yes' onClick={handleSLChangeSubmit} autoFocus>
            Submit
          </Button>
        </DialogActions>
      </Dialog>



      {/* Dialog to confirm remove row  */}
      <Dialog
        open={RemoveAlert}
        onClose={() => SetRemoveAlert(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ color: "#2380DE", width: '100%', textAlign: 'center', display: 'block' }} id="alert-dialog-title">
          {"Confirmation "}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure, you want to remove row
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="btn-cancel"
            variant="outlined"
            color="error"
            onClick={() => SetRemoveAlert(false)}
          >
            No
          </Button>
          <Button className="btn-submit"
            variant="outlined"
            color="success"
            onClick={handleremoveRow}
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>




      {/* dialog for error show */}

      <Dialog
        open={automateRemark}
        onClose={handleAutomateRemarkClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Enter Report Remark"}
        </DialogTitle>
        <DialogContent>
          <div style={{ width: '100%' }}>
            <label htmlFor="withCommentery" style={{ marginRight: '10px' }}>Send Telegram</label>
            <IOSSwitch
              sx={{ m: 1 }}
              defaultChecked
              checked={checked}
              onChange={handleChange}
              inputProps={{ "aria-label": "controlled" }}
            />
          </div>
          <div style={{ width: '100%' }}>
            <label htmlFor="Commentry" style={{ marginRight: '10px' }}>Commentary</label>
            <textarea
              id="inputField"
              placeholder="Type a message"
              value={commentrymessage}
              style={{ width: '100%', border: '2px solid black' }}
              onChange={(e) => setCommentryMessage(e.target.value)}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button className="btn-cancel"
            variant="outlined"
            color="error"
            onClick={handleAutomateRemarkClose}
          >
            Close
          </Button>
          <Button className="btn-submit"
            variant="outlined"
            color="success"
            onClick={automateSendToTelegram}
            autoFocus
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>


      {/* to show error message in alert */}
      <Dialog
        open={showAlert}
        onClose={() => { setshowAlert(false) }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <p style={{ color: "green", padding: '10px 30px 10px 30px', margin: 0 }}>{AlertMessage}</p>
      </Dialog>



      {/* Dailog for message send in telegram  favourable point gain message*/}

      <Dialog
        class="SLFirstMessage"
        open={MessageSLandFirstTraget}
        onClose={handleSLandFirstTragetClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Send Message"}
        </DialogTitle>
        <DialogContent>
          <div>Favourable Point: <span style={{ color: favourablePoint >= 0 ? 'green' : 'red' }}>{favourablePoint}</span></div>
          <div style={{ width: '350px' }}>
            <label htmlFor="Commentry" style={{ marginRight: '10px' }}>Remark</label>
            <textarea
              style={{ height: '150px', width: '100%', border: '1px solid black', margin: '0px' }}
              id="inputField"
              placeholder="Type a message"
              value={SlandFirstTargetmsg}
              onChange={(e) => setSlandFirstTargetmsg(e.target.value)}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button className="btn-cancel"
            variant="outlined"
            color="error"
            onClick={handleSLandFirstTragetClose}
          >
            Close
          </Button>
          <Button className="btn-submit"
            variant="outlined"
            color="success"
            onClick={SLandFirstSendToTelegram}
            autoFocus
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default IndexIntradayTable